<GoogleTagManager gtmId="GTM-PTKV2F39"></GoogleTagManager><router-view />
<!-- This will render the current route's component -->